import logger from '@/utils/logger'

export default async function getWebPushSubscription(): Promise<PushSubscription | null> {
  try {
    const registration = await navigator.serviceWorker.ready

    if (registration?.pushManager == null) {
      throw new Error('Notifications are not available on this browser or device')
    }

    const subscription = await registration.pushManager.getSubscription()

    return subscription
  } catch (err) {
    logger.error('Error getting web push subscription', { err })
    return null
  }
}
